module.exports = require("deep-extend");


//////////////////
// WEBPACK FOOTER
// external "deep-extend"
// module id = 241
// module chunks = 0